<template>
  <div class="container p-2" v-if="tes_id != '' && DateStep.Step1 != ''">
    <div class="container p-2">
      <div class="alert alert-primary text-center" role="alert">
        <div class="progress">
          <div
            class="progress-bar"
            role="progressbar"
            style="width: 70%"
            aria-valuenow="25"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            70%
          </div>
        </div>
        <h3 class="p-3">ขั้นตอนที่ 4</h3>
        ที่อยู่บิดามารดา...
      </div>
      <form @submit.prevent="SetStepStatus(6)">
        <div class="alert alert-secondary" role="alert">
          <div class="col-12 my-4 text-center">
            <h1><b>ที่อยู่บิดามารดา</b></h1>
            <h2 class="text-danger">
              รับสมัครปีการศึกษา {{ getDataFrom5.select_year }}
            </h2>
            <h6 class="text-danger">
              กรุณากรอกข้อมูลให้ครบทั้งหมด การสมัครเรียนแบ่งออกเป็น 5 ส่วน
              <br />
              <b>
                หากกรอกข้อมูลไม่ครบส่วนใดส่วนหนึ่ง
                จะถือว่าการสมัครเรียนหรือจองที่เรียนไม่สมบูรณ์</b
              ><br />
              หากไม่มีข้อมูลให้ใส่เครื่องหมาย<br />
              พบปัญหาเกี่ยวกับการกรอกข้อมูลติดต่อ 053-213061 ต่อ 112
            </h6>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-lg-12">
                <fieldset class="rounded-4 border border-primary p-3 mb-5">
                  <legend class="float-none w-auto px-3 fw-bold">
                    <h3 class="text-primary"><b> ที่อยู่บิดา</b></h3>
                  </legend>
                  <div class="form-group">
                    <div class="mb-5">
                      <div>
                        <input
                          class="form-check-input mx-2"
                          type="radio"
                          name="registration_F"
                          id="H_registration_F1"
                          v-model="H_registration_F"
                          @change="HselectF"
                        />
                        <label for="H_registration_F1" class="user-select-none">เหมือนตามที่อยู่ทะเบียนบ้าน</label>
                      </div>
                      <div>
                        <input
                          class="form-check-input mx-2"
                          type="radio"
                          name="registration_F"
                          id="C_registration_F2"
                          v-model="C_registration_F"
                          @change="CselectF"
                        />
                        <label for="C_registration_F2" class="user-select-none">เหมือนตามที่อยู่ปัจจุบัน</label>
                      </div>
                    </div>
                  </div>
                  <div class="row form-group d-flex justify-content-center">
                    <div class="col-lg-3 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">บ้านเลขที่</div>
                      </h6>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="บ้านเลขที่"
                        maxlength="35"
                        v-model="getDataFrom5.stu_homid_f"
                      />
                    </div>
                    <div class="col-lg-3 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">ซอย</div>
                      </h6>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="ซอย"
                        maxlength="25"
                        v-model="getDataFrom5.stu_soi_f"
                      />
                    </div>
                    <div class="col-lg-4 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">ถนน</div>
                      </h6>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="ถนน"
                        maxlength="25"
                        v-model="getDataFrom5.stu_road_f"
                      />
                    </div>
                  </div>
                  <div class="row form-group d-flex justify-content-center">
                    <div class="col-lg-3 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">จังหวัด</div>
                      </h6>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="getDataFrom5.stu_province_f"
                        @change="selectProvinceF()"
                      >
                        <option
                          value=""
                          selected
                          disabled
                          style="background-color: lightgray"
                        >
                          -
                        </option>
                        <option
                          v-for="item in getDataProvince"
                          :key="item.pro_code"
                          :value="item.pro_code"
                        >
                          {{ item.pro_name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-3 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex mb-4">อำเภอ</div>
                      </h6>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="getDataFrom5.stu_district_f"
                        @change="selectDistrictF()"
                      >
                        <option
                          value=""
                          selected
                          disabled
                          style="background-color: lightgray"
                        >
                          -
                        </option>
                        <option
                          v-for="item in getDataDistrictF"
                          :key="item.dis_id"
                          :value="item.dis_id"
                        >
                          {{ item.dis_name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-4 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">ตำบล</div>
                      </h6>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="getDataFrom5.stu_local_f"
                        @change="loadPostCode('postcode_f')"
                      >
                        <option
                          value=""
                          selected
                          disabled
                          style="background-color: lightgray"
                        >
                          -
                        </option>
                        <option
                          v-for="item in getDataLocalityF"
                          :key="item.loc_id"
                          :value="item.loc_id"
                        >
                          {{ item.loc_name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row form-group d-flex justify-content-center">
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">รหัสไปรษณีย์</div>
                      </h6>
                      <input
                        type="text"
                        class="form-control IsNumber"
                        placeholder="รหัสไปรษณีย์"
                        maxlength="6"
                        inputmode="numeric"
                        v-model="getDataFrom5.stu_postcode_f"
                      />
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">เบอร์โทรศัพท์</div>
                      </h6>
                      <input
                        type="text"
                        class="form-control IsNumber"
                        placeholder="เบอร์โทรศัพท์"
                        maxlength="10"
                        minlength="10"
                        inputmode="numeric"
                        v-model="getDataFrom5.stu_phone_f"
                      />
                    </div>
                  </div>
                  <div class="row form-group d-flex justify-content-center">
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">สถานที่ทำงาน</div>
                      </h6>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="สถานที่ทำงาน"
                        maxlength="35"
                        v-model="getDataFrom5.stu_fathe_wplace"
                      />
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">เบอร์ที่ทำงาน</div>
                      </h6>
                      <input
                        type="text"
                        class="form-control IsNumber"
                        placeholder="เบอร์ที่ทำงาน"
                        maxlength="10"
                        minlength="10"
                        inputmode="numeric"
                        v-model="getDataFrom5.stu_fplace_phone"
                      />
                    </div>
                  </div>
                </fieldset>
              </div>
              <!-- 

           -->
              <div class="col-lg-12">
                <fieldset class="rounded-4 border border-primary p-3 mb-5">
                  <legend class="float-none w-auto px-3 fw-bold">
                    <h3 class="text-primary"><b> ที่อยู่มารดา</b></h3>
                  </legend>
                  <div class="form-group">
                    <div class="mb-5">
                      <div>
                        <input
                          class="form-check-input mx-2"
                          type="radio"
                          name="registration_M"
                          id="H_registration_M1"
                          v-model="H_registration_F"
                          @change="HselectM"
                        />
                        <label for="H_registration_M1" class="user-select-none">เหมือนตามที่อยู่ทะเบียนบ้าน</label>
                      </div>
                      <div>
                        <input
                          class="form-check-input mx-2"
                          type="radio"
                          name="registration_M"
                          id="C_registration_M2"
                          v-model="H_registration_F"
                          @change="CselectM"
                        />
                        <label for="C_registration_M2" class="user-select-none">เหมือนตามที่อยู่ปัจจุบัน</label>
                      </div>
                    </div>
                  </div>
                  <div class="row form-group d-flex justify-content-center">
                    <div class="col-lg-3 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">บ้านเลขที่</div>
                      </h6>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="บ้านเลขที่"
                        maxlength="35"
                        v-model="getDataFrom5.stu_homid_m"
                      />
                    </div>
                    <div class="col-lg-3 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">ซอย</div>
                      </h6>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="ซอย"
                        maxlength="25"
                        v-model="getDataFrom5.stu_soi_m"
                      />
                    </div>
                    <div class="col-lg-4 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">ถนน</div>
                      </h6>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="ถนน"
                        maxlength="25"
                        v-model="getDataFrom5.stu_road_m"
                      />
                    </div>
                  </div>
                  <div class="row form-group d-flex justify-content-center">
                    <div class="col-lg-3 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">จังหวัด</div>
                      </h6>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="getDataFrom5.stu_province_m"
                        @change="selectProvinceM()"
                      >
                        <option
                          value=""
                          selected
                          disabled
                          style="background-color: lightgray"
                        >
                          -
                        </option>
                        <option
                          v-for="item in getDataProvince"
                          :key="item.pro_code"
                          :value="item.pro_code"
                        >
                          {{ item.pro_name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-3 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">อำเภอ</div>
                      </h6>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="getDataFrom5.stu_district_m"
                        @change="selectDistrictM()"
                      >
                        <option
                          value=""
                          selected
                          disabled
                          style="background-color: lightgray"
                        >
                          -
                        </option>
                        <option
                          v-for="item in getDataDistrictM"
                          :key="item.dis_id"
                          :value="item.dis_id"
                        >
                          {{ item.dis_name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-4 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">ตำบล</div>
                      </h6>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="getDataFrom5.stu_local_m"
                        @change="loadPostCode('postcode_m')"
                      >
                        <option
                          value=""
                          selected
                          disabled
                          style="background-color: lightgray"
                        >
                          -
                        </option>
                        <option
                          v-for="item in getDataLocalityM"
                          :key="item.loc_id"
                          :value="item.loc_id"
                        >
                          {{ item.loc_name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row form-group d-flex justify-content-center">
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">รหัสไปรษณีย์</div>
                      </h6>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="รหัสไปรษณีย์"
                        maxlength="6"
                        inputmode="numeric"
                        v-model="getDataFrom5.stu_postcode_m"
                      />
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">เบอร์โทรศัพท์</div>
                      </h6>
                      <input
                        type="text"
                        class="form-control IsNumber"
                        placeholder="เบอร์โทรศัพท์"
                        maxlength="10"
                        minlength="10"
                        inputmode="numeric"
                        v-model="getDataFrom5.stu_phone_m"
                      />
                    </div>
                  </div>
                  <div class="row form-group d-flex justify-content-center">
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">สถานที่ทำงาน</div>
                      </h6>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="สถานที่ทำงาน"
                        maxlength="35"
                        v-model="getDataFrom5.stu_mother_wplace"
                      />
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">เบอร์ที่ทำงาน</div>
                      </h6>
                      <input
                        type="text"
                        class="form-control IsNumber"
                        placeholder="เบอร์ที่ทำงาน"
                        inputmode="numeric"
                        maxlength="10"
                        minlength="10"
                        v-model="getDataFrom5.stu_mplace_phone"
                      />
                    </div>
                  </div>
                </fieldset>
              </div>
              <!-- {{ getDataFrom5 }} -->
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div
                class="col"
                v-if="getqrcodeChkStatusPay.status != 'Paysuccess'"
              >
                <div class="d-inline-flex p-2" style="float: left">
                  <button
                    type="button"
                    class="btn btn-primary"
                    v-on:click="SetStepStatus(4)"
                  >
                    <font-awesome-icon :icon="['fas', 'backward']" /> ย้อนกลับ
                  </button>
                </div>
                <div class="d-inline-flex p-2" style="float: right">
                  <button type="submit" class="btn btn-primary">
                    ถัดไป <font-awesome-icon :icon="['fas', 'forward']" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import $ from "jquery";
export default {
  data() {
    return {
      H_registration_F: "on",
      C_registration_F: "on",
      H_registration_M: "on",
      C_registration_M: "on",
    };
  },
  async mounted() {
    if (this.tes_id != "" && this.DateStep.Step1 != "") {
      // get Data Step2
    } else {
      await this.$swal({
        icon: "error",
        title: "Oops...",
        text: "กรุณาดำเนินการขั้นตอน Login ก่อน...",
      });
      this.$store.dispatch("Main/SetStepStatus", 1);
      return;
    }

    if (this.DateStep.Step2 == "") {
      await this.$swal({
        icon: "error",
        title: "Oops...",
        text: "กรุณาบันทึกข้อมูลในขั้นตอนที่ 1 ก่อน...",
      });
      await this.$store.dispatch("Main/SET_Onload", true);
      this.$store.dispatch("Main/SetStepStatus", 2);
      return;
    }

    this.$store.dispatch("Main/SET_Onload", false);
    await this.$store.dispatch("Step5/SetStep5");
    this.$store.dispatch("Step5/GET_DataProvince");
    this.$store.dispatch("Step5/POST_DataDistrictF");
    this.$store.dispatch("Step5/POST_DataLocalityF");
    this.$store.dispatch("Step5/POST_DataDistrictM");
    this.$store.dispatch("Step5/POST_DataLocalityM");
    this.$store.dispatch("Step5/POST_Student_Test");

    $(document).ready(function () {
      $(".IsNumber").keydown(function (e) {
        // Allow: backspace, delete, tab, escape, enter and .
        if (
          $.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
          // Allow: Ctrl+A
          (e.keyCode == 65 && e.ctrlKey === true) ||
          // Allow: home, end, left, right
          (e.keyCode >= 35 && e.keyCode <= 39)
        ) {
          // let it happen, don't do anything
          return;
        }
        // Ensure that it is a number and stop the keypress
        if (
          (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
          (e.keyCode < 96 || e.keyCode > 105)
        ) {
          e.preventDefault();
        }
      });
    });

    this.scrollToTop();
  },
  methods: {
    async loadPostCode(name) {
      if (name == "postcode_f") {
        for (const item of this.getDataLocalityF) {
          if (item.loc_id == this.getDataFrom5.stu_local_f) {
            this.getDataFrom5.stu_postcode_f = item.post_code;
            break;
          } else {
            this.getDataFrom5.stu_postcode_f = "";
          }
        }
      } else if (name == "postcode_m") {
        for (const item of this.getDataLocalityM) {
          if (item.loc_id == this.getDataFrom5.stu_local_m) {
            this.getDataFrom5.stu_postcode_m = item.post_code;
            break;
          } else {
            this.getDataFrom5.stu_postcode_m = "";
          }
        }
      }
    },
    HselectF() {
      // console.log(this.getStudentTest[0]);
      if (this.H_registration_F == "on") {
        this.getStudentTest.stu_homeid_reg
          ? (this.getDataFrom5.stu_homid_f =
              this.getStudentTest.stu_homeid_reg.trim())
          : "";
        this.getStudentTest.stu_soi_reg
          ? (this.getDataFrom5.stu_soi_f =
              this.getStudentTest.stu_soi_reg.trim())
          : "";
        this.getStudentTest.stu_road_reg
          ? (this.getDataFrom5.stu_road_f =
              this.getStudentTest.stu_road_reg.trim())
          : "";
        this.getStudentTest.stu_loality_reg
          ? (this.getDataFrom5.stu_local_f =
              this.getStudentTest.stu_loality_reg.trim())
          : "";
        this.getStudentTest.stu_district_reg
          ? (this.getDataFrom5.stu_district_f =
              this.getStudentTest.stu_district_reg.trim())
          : "";
        this.getStudentTest.stu_province_reg
          ? (this.getDataFrom5.stu_province_f =
              this.getStudentTest.stu_province_reg.trim())
          : "";
        this.getDataFrom5.stu_postcode_f = this.getStudentTest.stu_postcode_reg;
        this.$store.dispatch("Step5/POST_DataDistrictF");
        this.$store.dispatch("Step5/POST_DataLocalityF");
      }
    },
    CselectF() {
      if (this.C_registration_F == "on") {
        this.getDataFrom5.stu_homid_f = this.getStudentTest.stu_homeid;
        this.getDataFrom5.stu_soi_f = this.getStudentTest.stu_soi;
        this.getDataFrom5.stu_road_f = this.getStudentTest.stu_road;
        this.getDataFrom5.stu_local_f = this.getStudentTest.stu_locality;
        this.getDataFrom5.stu_district_f = this.getStudentTest.stu_district;
        this.getStudentTest.stu_province
          ? (this.getDataFrom5.stu_province_f =
              this.getStudentTest.stu_province.trim())
          : "";
        this.getDataFrom5.stu_postcode_f = this.getStudentTest.stu_postcode;
        this.$store.dispatch("Step5/POST_DataDistrictF");
        this.$store.dispatch("Step5/POST_DataLocalityF");
      }
    },
    HselectM() {
      if (this.H_registration_M == "on") {
        this.getDataFrom5.stu_homid_m = this.getStudentTest.stu_homeid_reg;
        this.getDataFrom5.stu_soi_m = this.getStudentTest.stu_soi_reg;
        this.getDataFrom5.stu_road_m = this.getStudentTest.stu_road_reg;
        this.getStudentTest.stu_loality_reg
          ? (this.getDataFrom5.stu_local_m =
              this.getStudentTest.stu_loality_reg.trim())
          : "";
        this.getStudentTest.stu_district_reg
          ? (this.getDataFrom5.stu_district_m =
              this.getStudentTest.stu_district_reg.trim())
          : "";
        this.getStudentTest.stu_province_reg
          ? (this.getDataFrom5.stu_province_m =
              this.getStudentTest.stu_province_reg.trim())
          : "";
        this.getDataFrom5.stu_postcode_m = this.getStudentTest.stu_postcode_reg;
        this.$store.dispatch("Step5/POST_DataDistrictM");
        this.$store.dispatch("Step5/POST_DataLocalityM");
      }
    },
    CselectM() {
      if (this.C_registration_M == "on") {
        this.getDataFrom5.stu_homid_m = this.getStudentTest.stu_homeid;
        this.getDataFrom5.stu_soi_m = this.getStudentTest.stu_soi;
        this.getDataFrom5.stu_road_m = this.getStudentTest.stu_road;
        this.getStudentTest.stu_province
          ? (this.getDataFrom5.stu_province_m =
              this.getStudentTest.stu_province.trim())
          : "";
        this.getDataFrom5.stu_district_m = this.getStudentTest.stu_district;
        this.getDataFrom5.stu_local_m = this.getStudentTest.stu_locality;
        this.getDataFrom5.stu_postcode_m = this.getStudentTest.stu_postcode;
        this.$store.dispatch("Step5/POST_DataDistrictM");
        this.$store.dispatch("Step5/POST_DataLocalityM");
      }
    },
    async selectProvinceF() {
      this.$store.dispatch("Main/SET_Onload", false);
      await this.$store.dispatch("Step5/POST_DataDistrictF");
      await this.$store.dispatch("Step5/POST_DataLocalityF");
      this.loadPostCode("postcode_f");
    },
    async selectProvinceM() {
      this.$store.dispatch("Main/SET_Onload", false);
      await this.$store.dispatch("Step5/POST_DataDistrictM");
      await this.$store.dispatch("Step5/POST_DataLocalityM");
      this.loadPostCode("postcode_m");
    },
    async selectDistrictF() {
      await this.$store.dispatch("Main/SET_Onload", false);
      await this.$store.dispatch("Step5/POST_DataLocalityF");
      this.loadPostCode("postcode_f");
    },
    async selectDistrictM() {
      await this.$store.dispatch("Main/SET_Onload", false);
      await this.$store.dispatch("Step5/POST_DataLocalityM");
      this.loadPostCode("postcode_m");
    },

    numberWithCommas(value) {
      return this.$options.filters.formatNumber(value);
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // เพื่อให้การเลื่อนเป็นแบบนุ่มนวล
      });
    },
    //ค้างทำ 7/6/67
    async SetStepStatus(payload) {
      await this.$store.dispatch("Main/SET_Onload", true);
      this.getDataFrom5.tes_id = this.tes_id;
      await this.$store.dispatch("Step5/SetStepStatus");
      if (this.DateStep5.status == true) {
        await this.$swal({
          icon: this.DateStep5.type,
          title: this.DateStep5.alert,
          text: this.DateStep5.text,
        });
        this.$store.dispatch("Main/SetStepStatus", payload);
      } else if (this.DateStep5.status == false) {
        await this.$swal({
          icon: this.DateStep5.type,
          title: this.DateStep5.alert,
          html: `${this.DateStep5.text}<br><a href="https://m.me/lannapolyCNX" target="_blank" style="color: blue; text-decoration: none;">Facebook Messenger</a>/<a href="https://line.me/ti/p/~@lannapoly" target="_blank" style="color: blue; text-decoration: none;">Line</a>`,
        });
      }
      if (this.tes_id != "" && this.DateStep.Step1 != "") {
        // get Data Step2
      } else {
        await this.$swal({
          icon: "error",
          title: "Oops...",
          text: "กรุณาดำเนินการในขั้นตอนที่ 1 ก่อน...",
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      tes_id: "Main/_getTesID",
      DateStep: "Main/_getDateStep",
      DateStep5: "Main/_getDateStep5",
      getDataFrom5: "Step5/_getDataFrom5",
      getDataFrom4: "Step4/_getDataFrom4",
      getDataProvince: "Step5/_getDataProvince",
      getDataDistrictF: "Step5/_getDataDistrictF",
      getDataLocalityF: "Step5/_getDataLocalityF",
      getDataDistrictM: "Step5/_getDataDistrictM",
      getDataLocalityM: "Step5/_getDataLocalityM",
      getSetStep4: "Step5/_SetStep5",
      getStudentTest: "Step5/_getDataStudent_test",
      getqrcodeChkStatusPay: "Step6/_getqrcodeChkStatusPay",
    }),
  },
};
</script>

<style></style>
